import { OutlinedEditFilter } from '@hose/eui-icons';
import { Button, Input } from '@hose/eui';
import React from 'react';
var getColumnMoney = function (cellRender) {
    var moneyArr = ['', ''];
    var reg = /^-?\d*(\.\d*)?$/;
    var handleMoneySearch = function (selectedKeys, confirm) {
        confirm();
    };
    var handleMoneyReset = function (clearFilters) {
        clearFilters();
        moneyArr = [];
    };
    var onMoneyStartChange = function (value, setSelectedKeys) {
        if (reg.test(value) || value === '' || value === '-') {
            moneyArr = [value, moneyArr[1]];
        }
        setSelectedKeys(moneyArr);
    };
    var onMoneyEndChange = function (value, setSelectedKeys) {
        if (reg.test(value) || value === '' || value === '-') {
            moneyArr = [moneyArr[0], value];
        }
        setSelectedKeys(moneyArr);
    };
    return {
        filterDropdown: function (_a) {
            var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters, close = _a.close;
            return (React.createElement("div", { style: { padding: 4, width: '264px' }, onKeyDown: function (e) { return e.stopPropagation(); } },
                React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' } },
                    React.createElement(Input, { style: { width: '117px' }, value: selectedKeys[0], onChange: function (e) { return onMoneyStartChange(e.target.value, setSelectedKeys); } }),
                    "\uFF5E",
                    React.createElement(Input, { style: { width: '117px' }, value: selectedKeys[1], onChange: function (e) { return onMoneyEndChange(e.target.value, setSelectedKeys); } })),
                React.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'end' } },
                    React.createElement(Button, { category: "secondary", onClick: function () { return clearFilters && handleMoneyReset(clearFilters); }, size: "small", style: { width: 40, marginRight: '4px' } }, "\u91CD\u7F6E"),
                    React.createElement(Button, { category: "primary", onClick: function () { return handleMoneySearch(selectedKeys, confirm); }, size: "small", style: { width: 40 } }, "\u786E\u8BA4"))));
        },
        filterIcon: function () { return (React.createElement(OutlinedEditFilter, { fontSize: 16, style: { color: 'var(--eui-icon-n2)' } })); },
        render: cellRender
    };
};
export default getColumnMoney;
